'use strict';
const screen = require('./screen.js');

function initPdfViewer(callback) {
  if (screen.isMobile() || screen.isTablet()) return;

  let pdfViewer = document.getElementById('pdf-viewer');
  if (pdfViewer != null) {
    let viewer = document.createElement('iframe');
    viewer.setAttribute('src', pdfViewer.getAttribute('data-src'));
    pdfViewer.appendChild(viewer);
  }
}

module.exports = {
  initPdfViewer
};



// WEBPACK FOOTER //
// ./src/js/pdf.js